import React, { useState, useEffect } from "react"
import {isImageSquare} from "../../util/isImageSquare"
import { Link } from "gatsby"

const ConditionalWrapper = ({ condition, wrapper, children }) => 
  condition ? wrapper(children) : children;

const TrainingCard = props => {
  const [, setStepNo] = useState(0)
  const [, setTotalStep] = useState(0)
  const { title, uri, slug, acf } = props.cardData.node
  const { cardTitle, setCardTitle } = props
  const type = props.cardData.node.nodeType?.toLowerCase() ?? "training"
  const urlbase = type === `training` ? `usecase` : `tutorial`;

  useEffect(() => {
    let stepStorage =
      localStorage.getItem("TrainingStep") &&
      JSON.parse(localStorage.getItem("TrainingStep"))
    if (stepStorage) {
      let index = stepStorage?.findIndex(step => step.title === title)
      setStepNo(stepStorage[index]?.stepNo || 0)
      setTotalStep(stepStorage[index]?.totalSteps || 0)
    } else {
      if (acf?.tenjinTrainingSteps) {
        setTotalStep(acf?.tenjinTrainingSteps?.length || 0)
      }
    }
  }, [title, acf.tenjinTrainingSteps])
  
  return (
    <div
      role="button"
      tabIndex={0}
      aria-hidden="true"
      onMouseEnter={() => setCardTitle(title)}
      onMouseLeave={() => setCardTitle("")}
      className={`${type} h-card small_half_bg flex flex-shrink-0 mb-5 cursor-default`}
    >
      <ConditionalWrapper
        condition={!acf.tenjinNoContent}
        wrapper={children => <Link to={uri && `/${urlbase}/${slug}`}>{children}</Link>}
      >
        <div className={`test w-64 h-72 rounded-2xl overflow-hidden ${acf.tenjinNoContent !== true ? " shadow-xl" :""}`}>
          {cardTitle === title ? (
            <div className={`h-card h-full pb-6 pt-4 px-4 relative`}>
              <div className={`${acf.tenjinNoContent !== true ? "bg-primary " :"bg-gray-100"} absolute left-0 right-0 top-0 z-20 h-full flex flex-col`}>
                  <p
                    className={`text-base ${acf.tenjinNoContent !== true ? "text-white" :""}   ellipsis-title-7 px-6 leading-7 h-full w-full mt-11`}
                    dangerouslySetInnerHTML={{ __html: acf?.tenjinCardExcerpt ?? '' }}
                  />
              </div>
            </div>
          ) : (

            <div className={"h-card h-full pb-6 pt-4 px-4 relative"}>
              <div className={`absolute left-0 right-0 top-0 p-6 z-20 h-full flex flex-col ${acf.tenjinNoContent !== true ? "bg-white " :"bg-gray-100"}`} >
                <div className="flex flex-row justify-end relative space-x-1 h-6">
                  { acf?.tenjinUpcomingContent &&
                    <div className="bg-red-800 px-2 relative rounded text-white w-content align-middle z-50 bg-pill-upcoming">
                      <p className="font-medium text-sm">Upcoming</p>
                    </div>}
                  { acf?.tenjinNewContent &&
                    <div className="bg-red-800 px-2 relative rounded text-white w-content align-middle z-50 bg-pill-new">
                      <p className="font-medium text-sm">New</p>
                    </div>}
                  { acf?.tenjinPaidContent === 'paid' && urlbase !== 'tutorial' &&
                    <div className="bg-red-800 px-2 relative rounded text-white w-content align-middle z-50 bg-pill-paid">
                      <p className="font-medium text-sm">$ Paid</p>
                    </div>}
                  { acf?.tenjinPaidContent === 'free' && urlbase !== 'tutorial' &&
                    <div className="bg-red-800 px-2 relative rounded text-white w-content align-middle z-50 bg-pill-free">
                      <p className="font-medium text-sm">Free</p>
                    </div>}
                  {!!acf.tenjinArticleNumber &&
                    <div className="bg-red-800 px-2 relative rounded text-white w-content align-middle z-50 bg-pill-articlenr">
                      <p className="font-medium text-sm">{acf.tenjinArticleNumber}</p>
                    </div>}
                </div>

                <h4
                  className={`ellipsis-title-4 font-black text-font-primary opacity-80 leading-8 mt-4 text-2xl`}
                  dangerouslySetInnerHTML={{ __html: title }}
                ></h4>
                <div className="absolute bottom-5">
                  <div className="flex mb-2">
                    {acf?.tenjinRelatedContent?.length > 0 &&
                      acf?.tenjinRelatedContent
                        ?.map((trainIcon, index) => {
                          const width = trainIcon?.acf?.iconColor?.mediaDetails?.width;
                          const height = trainIcon?.acf?.iconColor?.mediaDetails?.height;
                          if (trainIcon.acf?.iconColor ) {
                            return (
                              <img
                                key={index}
                                className={`block mr-2 ${isImageSquare(width, height) ? "w-7 h-7" : "h-7"}`}
                                alt={trainIcon.acf?.iconAlt ?? trainIcon.title}
                                src={
                                  trainIcon.acf?.iconColor?.sourceUrl
                                    ? trainIcon.acf.iconColor.sourceUrl
                                    : "https://via.placeholder.com/64x64/?text=no+image"
                                }
                              />
                            )
                          }
                          return null
                        })}
                  </div>
                  <p>{type === `training` ? `Use Case` : `Tutorial`}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </ConditionalWrapper>
    </div>
  )
}

export default TrainingCard
